import createModel from "../createModel";

import { PersonalDataAttribute } from "./PersonalDataAttribute";

export const PersonalDataSection = createModel("PersonalDataSection", (json) => ({
    id: json.IdRole,
    title: json.RoleType,
    attributes: PersonalDataAttribute.fromServerList(json.Attributes),
}));
